import { uri } from '../../api-endpoint';
import { deleteTemplateFn } from '../common';

export const deleteCompany = (token: string) => (companyId: number) =>
  deleteTemplateFn(token, uri.companyById(companyId));

/*

403
"\"company-001\" has related projects or models."

*/
